enum Status {
  ACTIVE
  PENDING
  DISABLED
  INVALID_STATUS
  STARTER
}

enum OrderBy {
  primary_role_id
  none
}

enum Order {
  asc
  desc
  none
}

type FirstTimeFeature {
  feature: String!
  complete: Boolean
}

type FirstTimeAccess {
  complete: Boolean
  features: [FirstTimeFeature!]
}

type UserCredentials {
  username: String
  password: String
  provider: String
  metadata: UserCredentialsMetadata
}

type UserCredentialsMetadata {
  IRESS_USER_CODE: String
}

type User {
  id: ID!
  organisation_id: ID!
  organisation(useClientApi: Boolean, includeFinancialConfigFields: Boolean): Organisation
  first_name: String
  last_name: String
  email_address: String
  first_time_access: FirstTimeAccess
  phone_number: String
  mobile_number: String
  primary_role_id: String
  role_name: String
  status: Status
  address: Address
  cases: [Case]
  metadata: [UserMetadata!]
  client_record: [ClientVersion]
  group_ids: [String!]
  credentials: [UserCredentials!]
  authentications: [Authentication]
  user_firm_identifier: String
  photo: String
  employment_basis: String
  part_time_percentage: Int
  training_and_competency: TrainingAndCompetancy
  agency_codes: [AgencyCode]
  compliance_settings: ComplianceSettings
}

type ComplianceSettings {
  under_review: AdviserUnderReview
}

type AdviserUnderReview {
  flagged: Boolean
}

type AgencyCode {
  provider_id: ID!
  agency_code: String!
}

type TrainingAndCompetancy {
  mortgage_qualifications: [String]
  protection_qualifications: [String]
  equity_release_qualifications: [String]
}

type Authentication {
  provider_name: String
  provider_subject: String
}

type UserMetadata {
  name: String
  string_value: String
  bool_value: Boolean
  int_value: Int
  user_editable: Boolean
}

type Role {
  role_id: ID!
  role_name: String!
}

input FirstTimeFeatureInput {
  feature: String!
  complete: Boolean
}

input FirstTimeAccessInput {
  complete: Boolean
  features: [FirstTimeFeatureInput!]
}

input UserInput {
  first_name: String
  last_name: String
  email_address: String
  first_time_access: FirstTimeAccessInput
  phone_desk: String
  phone_mobile: String
  status: Status
  primary_role_id: String
  metadata: [UserMetadataInput!]
  group_ids: [String!]
  credentials: [UserCredentialsInput!]
  organisation_id: String
  authentications: [AuthenticationsInput]
  user_firm_identifier: String
  photo: String
  employment_basis: String
  part_time_percentage: Int
  training_and_competency: TrainingAndCompetancyInput
  agency_codes: [AgencyCodeInput]
  skip_welcome_email: Boolean
  compliance_settings: ComplianceSettingsInput
}

input ComplianceSettingsInput {
  under_review: AdviserUnderReviewInput
}

input AdviserUnderReviewInput {
  flagged: Boolean
}

input TrainingAndCompetancyInput {
  mortgage_qualifications: [String]
  protection_qualifications: [String]
  equity_release_qualifications: [String]
}

input AuthenticationsInput {
  provider_name: String
  provider_subject: String
}

input UserMetadataInput {
  name: String
  string_value: String
  bool_value: Boolean
  int_value: Int
  user_editable: Boolean
}

input AgencyCodeInput {
  provider_id: ID
  agency_code: String
}

input UserCredentialsInput {
  username: String
  password: String
  provider: String
  metadata: UserCredentialsInputMetadata
}

input UserCredentialsInputMetadata {
  IRESS_USER_CODE: String
}

input CaseOwnerUserRoles {
  principal: Boolean
  firmManager: Boolean
  advisor: Boolean
}

type SupportUser {
  email: String
  org_id: String
  name: String
}

type ResetMfaResponse {
  success: Boolean!
  user_id: String!
}
